export const buildMyBookingDataFilter = ({ dateFrom, dateTo, userId }) =>
  JSON.stringify({
    and: [
      { active: { eq: true } },
      {
        and: [{ dateFrom: { le: dateTo } }, { dateTo: { ge: dateFrom } }],
      },
      {
        or: [
          { reservedForUsers: { contains: userId } },
          { assistent: { contains: userId } },
          { createdBy: { eq: userId } },
        ],
      },
    ],
  });
